/**
 * @file: useRemoveProductManifestItem.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ProductManifestManager } from '@euler/app/flows/task/functions/task-detail/product-manifest/ProductManifestManager';
import { useAppLoading } from '@euler/components/loading/Provider';
import { useConfirm } from '@euler/functions/ux/useConfirm';
import { IdType } from '@euler/model/common';
import { SaveTaskProductManifestOriginInfo } from '@euler/model/task-detail';
import { idEquals } from '@euler/utils';
import { useCallback } from 'react';

export const useRemoveProductManifestItem = (props: {
  origin: SaveTaskProductManifestOriginInfo;
}) => {
  const loading = useAppLoading();
  const confirm = useConfirm();
  return useCallback(
    async (
      productManifestManager: ProductManifestManager,
      subject: string,
      productId: IdType,
      options?: {
        stage?: boolean;
      },
    ) => {
      if (
        await confirm({
          title: '确认',
          message: '是否确认移除该产品推荐? ',
        })
      ) {
        if (options?.stage) {
          productManifestManager.removeProductForSubject(subject, productId);
        } else {
          const payload = productManifestManager.getSavePayload(props.origin);
          payload.items = payload.items.map(item =>
            item.subject === subject && idEquals(item.productId, productId)
              ? { ...item, remove: true }
              : item,
          );
          await loading.showWithAction(async () => {
            await productManifestManager.save({
              payload,
              origin: props.origin,
            });
          });
        }
      }
    },
    [confirm, loading, props.origin],
  );
};
